import { dialog } from "nq-component";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import DialogModal from "../../../../components/Dialog";
import {
  computePartialCosts,
  computeTotalCost,
} from "../../../../componentCostUtils";
import { da } from "date-fns/locale";
import { findObjectUseCase } from "../../../../usecases/object";
import { auditLogUseCase } from "../../../../usecases/logs";

class DirectPurchaseFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    // Preserve raw_materials if present in the view
    if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
      this.object.raw_materials = [...this.view.state.object.raw_materials];
    }

    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = { include: ["raw_materials", "raw_materials.uom", "uom"] };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async save() {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    const rawMaterials = computePartialCosts(
      this.view.state.object.raw_materials || []
    );

    this.change.raw_materials = rawMaterials;
    const parentData = this.change;

    try {
      for (const material of rawMaterials) {
        const {
          id,
          component_quantity,
          acl,
          created,
          updated,
          stock_quantity,
          unit_cost,
          partial_cost,
          cost,
          ...cleanedMaterial
        } = material;

        const payload = {
          ...cleanedMaterial,
          description: parentData.description,
          quantity: String(material.quantity),
          uom: { id: material.uom.id },
          price: material.cost,
          storeId: material.storeId,
          sku: material.sku,
          itemName: material.itemName,
          raw_materials: parentData?.raw_materials,
          storeId: { id: user.storeAnalytic[0]?.id },
        };

        const responseDP = await this.upsertUseCase.execute(
          collection,
          payload
        );

        // --- inventory update block ---
        const inventoryItem = await findObjectUseCase().execute("inventory", {
          where: {
            itemName: material.itemName,
            "storeId.id": { $eq: user?.storeAnalytic?.[0]?.id },
          },
          limit: 1,
        });
        let responseInv = null;
        if (inventoryItem?.length > 0) {
          const currentInventory = inventoryItem[0];
          const currentCount = parseFloat(currentInventory.systemCount || "0");
          const addedQty = parseFloat(material.quantity || "0");
          const updatedCount = (currentCount + addedQty).toFixed(2);

          responseInv = await this.upsertUseCase.execute("inventory", {
            id: currentInventory.id,
            systemCount: String(updatedCount),
          });

          await auditLogUseCase().create({
            user: { id: user.id },
            logDate: new Date().toISOString(),
            message: `Added ${addedQty} to inventory: ${material.itemName}, old stock: ${currentCount}, new stock: ${updatedCount}`,
            collection: "inventory",
            objectId: currentInventory.id,
            payload: {
              material,
              responseInv,
            },
            store: { id: user.storeAnalytic?.[0]?.id },
          });
        }

        await auditLogUseCase().create({
          user: { id: user.id },
          logDate: new Date().toISOString(),
          message: `Saved direct purchase for ${material.itemName}, quantity: ${material.quantity}, total cost: ${material.cost}`,
          collection,
          objectId: responseDP.id,
          payload: {
            material,
            response: responseDP,
            responseInv,
          },
          store: { id: user.storeAnalytic?.[0]?.id },
        });
      }

      this.change = {}; // Clear state after success
      this.view.hideProgressDialog();
    } catch (error) {
      console.error("Error saving material:", error);
      throw error;
    }
  }

  async submit() {
    // if (Object.values(this.change).length === 0) {
    //   this.view.showSuccessSnackbar("Successfully saved!");
    //   return;
    // }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default DirectPurchaseFormPresenter;
